// extracted by mini-css-extract-plugin
export default {"comingSoon":"styles_comingSoon__Nw47a"};